import _ from "lodash";

import * as path from "../path";
import BaseNode from "./baseNode";

export default class PropertyNode extends BaseNode {
	static get modelName() {
		return "PropertyNode";
	}

	constructor(k4node) {
		super(k4node);

		const meta = k4node.meta() || {};
		this.required = meta.required || false;
		this.options = meta.options || {};

		// Perform any validation that can only happen during construction, while
		// we have access to the originating k4model node.
		if (meta.type === "path") {
			const targetPath = path.normalize(this.value);
			const isBlank = _.isNil(targetPath) || targetPath === "";
			if (!isBlank && !k4node.root().child(targetPath)) {
				this.addValidationError(`Invalid path: ${this.value}`);
			}
		}
	}

	_validate() {
		// Check for required properties that are blank
		const isBlank = _.isNil(this.value) || this.value === "";
		if (isBlank && this.required)
			this.addValidationError(
				`Required property "${this.name}" should not be blank`
			);
		// Check for invalid numeric properties
		else if (this.type === "number") {
			const num = _.toNumber(this.value);
			if (_.isNaN(num)) {
				this.addValidationError(`Expected a number: ${this.value}`);
			} else if (this.options) {
				const { min, max } = this.options;
				if (min && num < min)
					this.addValidationError(
						`Expected number greater than ${min} but got ${num}`
					);
				if (max && num > max)
					this.addValidationError(
						`Expected number less than ${max} but got ${num}`
					);
			}
		}

		this._valid = _.isEmpty(this._errors);
	}
}
